import { isFeatureEnabled } from "@/config/feature-flags";

/**
 * Prüft, ob das i18n-Feature aktiviert ist.
 * @returns true wenn I18N_ENABLED Flag gesetzt ist, sonst false
 */
export function isI18nEnabled(): boolean {
  return isFeatureEnabled("I18N_ENABLED");
}
